import PropTypes from 'prop-types';
import React from 'react';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { connect, ApiCall, Grid, ConfirmDialog } from 'omni-common-ui';
import { List } from 'immutable';
import CourseViewTable from 'components/CourseViewTable';
import { actions as GroupMembers } from 'data/GroupMembers';
import { actions as UnlockHomeworkActions } from 'data/UnlockHomework';
import * as accessors from 'data/UnlockHomework/accessors';
import UnsavedChangesWarning from 'components/UnsavedChangesWarning';
import UnsavedChangesTrackingPageComponent from 'components/UnsavedChangesTrackingPageComponent';
import UnlockManualInput from './UnlockManualInput';

const HEADER_LATEST = 'latest';
const HEADER_MANUAL = 'manual';

class UnlockHomework extends UnsavedChangesTrackingPageComponent {
  constructor(props) {
    super(props);
    this._renderCell = this._renderCell.bind(this);
  }

  componentWillMount() {
    this.setState({
      allowRouteLeave: false,
      isChanged: false,
      unlockHomeworks: undefined,
    });
    this.props.fetchUnlockHomework(this.props.groupId);
    this._clearUnlockHomeworkFaiure(this.props.unlockHomeworkError &&
        this.props.unlockHomeworkError.id);
    this._changeUnlockable(false);
    super.componentWillMount();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.unlockHomeworks !== nextProps.unlockHomeworks || ! this.state.unlockHomeworks) {
      this.setState({
        allowRouteLeave: false,
        isChanged: false,
        unlockHomeworks: nextProps.unlockHomeworks,
      });
    }
  }

  routerWillLeave(nextLocation) {
    if (nextLocation && nextLocation.pathname.endsWith('/unlock')) {
      this._onSaveClick().then(() =>
        ! this.props.unlockHomeworkError &&
          this.props.fetchUnlockHomework(this.props.groupId));
      return false;
    }
    return super.routerWillLeave(nextLocation);
  }

  _isChangesPresent() {
    const { unlockHomeworks, isChanged } = this.state;
    return this.props.mode &&
      !! isChanged && accessors.isUnlockHomeworksUnlockable(unlockHomeworks);
  }

  _onSaveClick() {
    let { unlockHomeworks } = this.state;
    unlockHomeworks = unlockHomeworks.filter((unlockHomework) =>
      !! unlockHomework.manualLessonSequence).map((unlockHomework) => ({
        studentId: Number(unlockHomework.studentId, 10),
        manualLessonSequence: Number(unlockHomework.manualLessonSequence, 10),
      })).toList();
    this._changeUnlockable(false);
    return this.props.updateUnlockHomeworks(this.props.groupId, unlockHomeworks);
  }

  _clearUnlockHomeworkFaiure(errorKey) {
    if (errorKey) {
      this.props.clearApiCallError(errorKey);
    }
  }

  _changeUnlockable(status) {
    if (status) {
      this._forcePushRoute(this.props.buildRoute({ mode: 'edit-unlock' }));
    } else {
      this._forcePushRoute(this.props.buildRoute({ mode: '' }));
    }
  }

  _onChange(studentId, ev) {
    let { unlockHomeworks } = this.state;
    unlockHomeworks = unlockHomeworks.update(studentId, (unlockHomework) =>
        unlockHomework.set('manualLessonSequence', ev && Number(ev, 10)));
    if (accessors.isUnlockHomeworksUnlockable(unlockHomeworks)) {
      this._changeUnlockable(true);
      this.setState({ isChanged: true });
    } else {
      this._changeUnlockable(false);
    }
    this.setState({ unlockHomeworks });
  }

  _renderUnlockHomeworkErrorDialog() {
    const { unlockHomeworkError } = this.props;
    if (! unlockHomeworkError) {
      return;
    }
    return <ConfirmDialog isOpen={!! unlockHomeworkError}
        primaryButtonContent="Ok"
        onPrimaryClick={() => {
          this._clearUnlockHomeworkFaiure(unlockHomeworkError.id);
          this._clearRequestedLocation();
          if (accessors.isUnlockHomeworksUnlockable(this.state.unlockHomeworks)) {
            this._changeUnlockable(true);
            this.setState({ isChanged: true });
          }
        }}>
      <span>{unlockHomeworkError.error.response.message}</span>
    </ConfirmDialog>;
  }

  _renderUnsavedChangesWarningDialog() {
    return <UnsavedChangesWarning isOpen={
          !! this._isNavigationWithChangesRequested()}
        dialogText="Do you want to unlock homework?"
        primaryButtonLabel="Unlock"
        secondaryButtonContent="Discard"
        isSaving={this.props.isAnyApiCallSaving}
        onSaveClicked={() => {
          this._onSaveClick().then(() =>
          ! this.props.unlockHomeworkError &&
            this._forcePushRequestedLocation()
          );
        }}
        onDiscardClicked={() => {
          this._forcePushRequestedLocation();
        }}
        onCloseClicked={() => {
          this._clearRequestedLocation();
        }} />;
  }

  _renderTableHeader() {
    const { unlockHomeworks } = this.state;
    return <CourseViewTable.Header>
      <CourseViewTable.Row>
        <CourseViewTable.Cell key={HEADER_LATEST}
            columnId={{ column: HEADER_LATEST, unlockHomeworks }}>
          Latest Lesson Unlocked
        </CourseViewTable.Cell>
        <CourseViewTable.Cell key={HEADER_MANUAL}
            columnId={{ column: HEADER_MANUAL, unlockHomeworks }}>
          Manual Lesson Override
        </CourseViewTable.Cell>
      </CourseViewTable.Row>
    </CourseViewTable.Header>;
  }

  _renderCell(member, { column, unlockHomeworks }) {
    const { canEdit } = this.props;
    const unlockHW = unlockHomeworks && unlockHomeworks.get(`${member.studentGeneralInfo.id}`);
    if (! unlockHW) {
      return;
    }

    switch (column) {
      case HEADER_LATEST: {
        const unitLesson = unlockHW.latestUnlockedSequence ?
          ` (S${unlockHW.sessionNumber} U${unlockHW.unitNumber} L${unlockHW.lessonNumber})` :
          '';
        return `${unlockHW.latestUnlockedSequence || '-'}/${unlockHW.totalLessonAmount || '-'}${unitLesson}`;
      }
      case HEADER_MANUAL: {
        const onChange = this._onChange.bind(this, unlockHW.studentId);
        return <UnlockManualInput key={unlockHW.studentId}
            disabled={! canEdit}
            onChange={onChange}
            min={unlockHW.latestUnlockedSequence}
            max={unlockHW.totalLessonAmount}
            manualLessonSequence={unlockHW.manualLessonSequence} />;
      }
      default:
        break;
    }
  }

  render() {
    const { members } = this.props;
    return <Grid outerMargin>
      <Grid.Group>
        <CourseViewTable students={members}>
          {this._renderTableHeader()}
          <CourseViewTable.Body>
            {this._renderCell}
          </CourseViewTable.Body>
        </CourseViewTable>
      </Grid.Group>
      {this._renderUnsavedChangesWarningDialog()}
      {this._renderUnlockHomeworkErrorDialog()}
    </Grid>;
  }

}

UnlockHomework.propTypes = {
  groupId: PropTypes.string.isRequired,
  mode: PropTypes.string,
  canEdit: PropTypes.string,
  members: PropTypes.object.isRequired,
  unlockHomeworks: PropTypes.object,
  fetchUnlockHomework: PropTypes.func.isRequired,
  updateUnlockHomeworks: PropTypes.func.isRequired,
  clearApiCallError: PropTypes.func.isRequired,
  replace: PropTypes.func.isRequired,
  buildRoute: PropTypes.func.isRequired,
  isAnyApiCallSaving: PropTypes.bool,
  unlockHomeworkError: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.undefined,
  ]),
};

export function mapStateToProps(state, ownProps) {
  const { groupId, mode } = ownProps.params;
  const members = GroupMembers.getMembersByGroup(state, groupId);
  const unlockHomeworks = accessors.getUnlockHomeworksByGroup(state, groupId);
  const unlockHomeworkError = getUnlockHomworkErrorCall(state);
  const canEdit = accessors.canEditUnlockHomework(state, groupId);
  return {
    members,
    unlockHomeworks,
    groupId,
    mode,
    canEdit,
    unlockHomeworkError,
    isAnyApiCallSaving: !! isAnyApiCallSaving(state),
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({},
    { pushRoute: (path) => dispatch(push(path)) },
    { clearApiCallError: (errorKey) => dispatch(ApiCall.clean(errorKey)) },
    bindActionCreators(GroupMembers, dispatch),
    bindActionCreators(UnlockHomeworkActions, dispatch),
  );
}

function isAnyApiCallSaving(state) {
  return !! (state.get('apiCalls') || new List())
    .filter((call, key) =>
      ['PUT', 'POST', 'DELETE'].some((method) => key.startsWith(method)))
        .find((call) => ApiCall.State.isLoading(call));
}

function getUnlockHomworkErrorCall(state) {
  return ApiCall.getAllErrors(state).filter((call) =>
      call.id.endsWith('unlock-homework') && call.id.startsWith('PUT')).first();
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UnlockHomework));



// WEBPACK FOOTER //
// ./containers/Group/AssignHomework/UnlockHomework/component.jsx